import { connect } from 'react-redux';
import SelectAgence from '../../components/Inputs/SelectAgence';
const mapStateToProps = state => ({ agence: state.demandeCredit.getIn(['agence', 'value']) });
export default connect(mapStateToProps)(SelectAgence);
